// extracted by mini-css-extract-plugin
module.exports = {"container":"SimilarVehiclesCarousel_container__urBj8","carousel":"SimilarVehiclesCarousel_carousel__6IbIC","navigation":"SimilarVehiclesCarousel_navigation__o0Q2X"};